import { useState, useEffect } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import Container from "@/components/ui/Container";

const TESTIMONIALS = [
  {
    title: "The best booking service",
    text: "So many variables that I hadn't even considered that make all the difference... I highly recommend using TravelHug for all your bookings...",
    user: "Syed Mahmood",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=11",
  },
  {
    title: "The best tour operators",
    text: "TravelHug made our holiday exactly tailored around our requirements... our booking and travel agent has been exceptional and sorted our holidays.",
    user: "Susan",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=5",
  },
  {
    title: "Absolutely wonderful experience",
    text: "From start to finish, the planning was seamless. Every detail was taken care of and we could just enjoy the journey without any stress.",
    user: "James Carter",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=12",
  },
  {
    title: "Perfect family vacation",
    text: "We traveled with three kids and TravelHug planned everything perfectly. Kid-friendly activities, great hotels, and smooth transfers throughout.",
    user: "Maria Lopez",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=32",
  },
  {
    title: "Exceeded all expectations",
    text: "I was skeptical at first, but the personalized itinerary was spot on. Every restaurant, every activity — it felt like they read my mind.",
    user: "David Kim",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=33",
  },
  {
    title: "A truly memorable trip",
    text: "TravelHug helped us discover hidden gems we would never have found on our own. The local tips and off-the-beaten-path suggestions were incredible.",
    user: "Priya Sharma",
    role: "User",
    avatar: "https://i.pravatar.cc/150?img=26",
  },
];

export function TestimonialsLanding() {
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  useEffect(() => {
    const update = () => setItemsPerPage(window.innerWidth < 768 ? 1 : 3);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const totalPages = Math.ceil(TESTIMONIALS.length / itemsPerPage);
  const visible = TESTIMONIALS.slice(
    page * itemsPerPage,
    page * itemsPerPage + itemsPerPage,
  );

  return (
    <section className="py-16 bg-[#FDF9F5]">
      <Container>
        <div className="flex justify-between items-end mb-8">
          <div>
            <h3 className="text-[#0F766E] font-medium text-lg">
              Testimonials
            </h3>
            <h2 className="text-slate-800 text-4xl font-bold mt-1">
              What people say about Us.
            </h2>
          </div>
          <div className="flex gap-2 pb-2">
            <button
              onClick={() => setPage((p) => Math.max(0, p - 1))}
              disabled={page === 0}
              className="w-10 h-10 rounded-full border border-[#EDE8E3] flex items-center justify-center text-slate-600 hover:bg-[#ED6F2E] hover:text-white hover:border-[#ED6F2E] transition-colors disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-slate-600 disabled:hover:border-[#EDE8E3]"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
              disabled={page >= totalPages - 1}
              className="w-10 h-10 rounded-full border border-[#EDE8E3] flex items-center justify-center text-slate-600 hover:bg-[#ED6F2E] hover:text-white hover:border-[#ED6F2E] transition-colors disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-slate-600 disabled:hover:border-[#EDE8E3]"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {visible.map((t, i) => (
            <div
              key={page * itemsPerPage + i}
              className="bg-white rounded-[24px] p-6 shadow-sm border border-[#EDE8E3] relative"
            >
              <h4 className="font-semibold text-slate-800 text-[15px] mb-3">
                {t.title}
              </h4>
              <p className="text-slate-500 text-sm leading-relaxed mb-6">
                &ldquo;{t.text}&rdquo;
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.user}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-[#ED6F2E]">
                      {t.user}
                    </div>
                    <div className="text-xs text-slate-400">{t.role}</div>
                  </div>
                </div>

                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star
                      key={star}
                      size={14}
                      className="fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
